/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Check_In_Journey_Complete_TitleInputs */

const en_check_in_journey_complete_title = /** @type {(inputs: Check_In_Journey_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reward journey complete`)
};

const es_check_in_journey_complete_title = /** @type {(inputs: Check_In_Journey_Complete_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recorrido de recompensas completado`)
};

/**
* | output |
* | --- |
* | "Reward journey complete" |
*
* @param {Check_In_Journey_Complete_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const check_in_journey_complete_title = /** @type {((inputs?: Check_In_Journey_Complete_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Check_In_Journey_Complete_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_check_in_journey_complete_title(inputs)
	return es_check_in_journey_complete_title(inputs)
});